import React from "react";
import { Switch, Route, Redirect } from 'react-router-dom';
import useToken from "shared/hook/useToken";

import Home from "views/Home";
import Manual from "views/Manual";
import UserProfile from "views/UserProfile";
import AdminUser from "views/AdminUser";
import AdminPowerbi from "views/AdminPowerbi";
import AdminReport from "views/AdminReport";
import AdmininQuiryform from "views/AdmininQuiryform";
import AdminEmail from "views/AdminEmail";
import AdminWheadSetting from "views/AdminWheadSetting";
import AdminFooterSetting from "views/AdminFooterSetting";
import Policy from "views/Policy";

import BannerSetting from "views/BannerSetting";
import Indicators from "views/Indicators";
import IndicatorsList from "views/IndicatorsList";
import ContentSetting from "views/ContentSetting";
import Contact from "views/Contact";
import ResetPassword from "views/ResetPassword";
import InterestingSetting from "views/InterestingSetting";
import LawContentList from "views/LawContentList";
import ActiveUser from "views/ActiveUser";



import {
  Api as PowerbiSettingApi,
  Keyin as PowerbiSettingKeyin,
  Uploadfile as PowerbiSettingUploadfile,
  Approve as PowerbiApprove,
  Detail as PowerbiDetail,
} from "views/PowerbiSetting";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { token } = useToken();

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: {
                from: props.location,
              },
            }}
          />
        )
      }
    />
  );
};


const NoUserRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => <Component {...props} />}
    />
  );
};

const RoutesApp = () => {
  const routes = [
    {
      path: "/manual",
      name: "Manual",
      component: Manual,
    },
    {
      path: "/user-profile",
      name: "UserProfile",
      component: UserProfile,
    },
    {
      path: "/administratorhome/banner",
      name: "Banner Setting",
      component: BannerSetting,
    },
    {
      path: "/administratorhome/contentmain",
      name: "Content Setting",
      component: ContentSetting,
    },
    {
      path: "/administratorhome/wheadsetting",
      name: "Whead Setting",
      component: AdminWheadSetting,
    },
    {
      path: "/administratorhome/footersetting",
      name: "Footer Setting",
      component: AdminFooterSetting,
    },
    {
      path: "/administratorhome/interesting",
      name: "Interesting Setting",
      component: InterestingSetting,
    },
    
    {
      path: "/administrator/report",
      name: "Admin Report",
      component: AdminReport,
    },
    {
      path: "/administrator/inquiryform",
      name: "Adminin Quiryform",
      component: AdmininQuiryform,
    },
    {
      path: "/administrator/email",
      name: "Admin Email",
      component: AdminEmail,
    },
    {
      path: "/administrator/users",
      name: "Administrator Users",
      component: AdminUser,
    },
    {
      path: "/administrator/powerbi",
      name: "Powerbi",
      component: AdminPowerbi,
    },
    {
      path: "/administrator/users",
      name: "Powerbi",
      component: AdminPowerbi,
    },
    // PowerbiSetting
    {
      path: "/powerbisetting/keyin",
      name: "Powerbi Keyin",
      component: PowerbiSettingKeyin,
    },
    {
      path: "/powerbisetting/uploadfile",
      name: "Powerbi Uploadfile",
      component: PowerbiSettingUploadfile,
    },
    {
      path: "/powerbisetting/api",
      name: "Powerbi API",
      component: PowerbiSettingApi,
    },
    {
      path: "/powerbilist",
      name: "Approve Powerbi",
      component: PowerbiApprove,
    },
    {
      path: "/powerbidetail/:id/:indicatorsId",
      name: "Powerbi Detail",
      component: PowerbiDetail,
      exact: true,
    },
  ]
  .map((route) => {
    return <PrivateRoute exact={route.exact} key={route.path} path={route.path} component={route.component} />
  });

  const routesNoUser = [
    {
      path: "/policy",
      name: "Policy",
      component: Policy,
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
    },
    {
      path: "/lawcontent/:id",
      name: "LawContentList",
      component: LawContentList,
    },
    {
      path: "/indicators",
      name: "Indicators",
      component: Indicators,
    },
    {
      path: "/indicators-list",
      name: "Indicators List",
      component: IndicatorsList,
    },
    {
      path: "/reset-password/:token",
      name: "Reset Passwordt",
      component: ResetPassword,
    },
    {
      path: "/active-user/:userId/:token",
      name: "Active User",
      component: ActiveUser,
    },
  ]
  .map((route) => {
    return <NoUserRoute exact={route.exact} key={route.path} path={route.path} component={route.component} />
  });
  

  return (
    <>
      <Switch>
        {routes}
        {routesNoUser}
        <Route path="/" component={Home} />
        {/* <Route exact render={() => <Component  path="/indicators" name="Indicators" component={Indicators}/> } /> */}
        <Redirect exact to="/" />
        <Route
          component={
            <main style={{ padding: "1rem" }}>
              <p>There's nothing here!</p>
            </main>
          }
        />
      </Switch>
    </>
  );
};

export default RoutesApp;
